// disabling eslint temporarily for this file until it can be refactored
/* eslint-disable */
import React from "react";

export const DEPTH_1 = 1;

// Clones child components. Note: ModalBody should always use a depth of 1. Any of the child components that require deeper branches should build them out themselves.
export const cloneChildComponents = (props, children, depth) => (
  <>
    {React.Children.map(children, (child) => {
      if (React.isValidElement(child)) {
        if (child?.props?.children && depth !== DEPTH_1) {
          return (
            <>
              {React.cloneElement(child, props)}
              {cloneChildComponents(props, child.props.children)}
            </>
          );
        }
        return <>{React.cloneElement(child, props)}</>;
      }
    })}
  </>
);

// Converts a provided value to a percentage value
export const convertValueToPercentage = (valueToConvert) => {
  let convertedValue = 0;
  if (typeof valueToConvert === "number" && valueToConvert !== 0) {
    convertedValue = 100 * (valueToConvert / 100);
  }
  return convertedValue;
};

// Converts a color to a background style
export const convertColorToStyle = (colorHex) => ({
  backgroundColor: colorHex,
});

// getPercentage between two values
export const getPercentage = (a, b) => {
  let percent;
  if (b !== 0) {
    if (a !== 0) {
      percent = ((b - a) / a) * 100;
    } else {
      percent = b * 100;
    }
  } else {
    percent = -a * 100;
  }
  return Math.floor(percent);
};

export const randomId = (length = 8) =>
  Math.random()
    .toString(36)
    .substring(2, length + 2);
